import {InaccessibleInfo} from 'auth/RequestAccess';
import {StorableSummary} from 'constants/SampleConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {modelInaccessible} from 'models/ManagedModelsReduxActions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import * as StorableActions from 'samples/StorableActions';
import StorableStore from 'samples/StorableStore';

export default class StorableSummaryModelManager extends ModelManager<ManagedModelType.STORABLE_SUMMARY> {
  constructor() {
    super(ManagedModelType.STORABLE_SUMMARY);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    await StorableActions.bulkFetchSummaries(keys);
    // Deleted storables and storables that we have insufficient privilege to see are simply not included
    const inaccessibleStorableIds = keys.filter((id) => !this.getModel(id));
    const inaccessibleInfoById: {[storableId: string]: InaccessibleInfo} = {};
    // Ideally we'd get this response from the server, this is a hack for now to produce the inaccessibleInfo.
    inaccessibleStorableIds.forEach((id) => {
      inaccessibleInfoById[id] = {invalidId: id};
    });
    getStore().dispatch(modelInaccessible(ManagedModelType.STORABLE_SUMMARY, inaccessibleInfoById));
  }

  getModel(modelKey: string): StorableSummary | null {
    return StorableStore.getStorableSummary(modelKey);
  }
}
